/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {
    class ResultTypeListController {
        constructor(private $mdDialog: ng.material.IDialogService) {

        }


        private popupDialog(img, video) {
            this.$mdDialog.show({
                parent: angular.element(document.querySelector('.result-types')),
                clickOutsideToClose: true,
                controller: function ($scope, $mdDialog) { $scope.close = function () { $mdDialog.hide() } },
               
                template:
                `<md-dialog class='screenshot-popup'>
    <md-toolbar>
      <div class="md-toolbar-tools">
        <h2>Screenshot / Video</h2>
        <span flex></span>
        <md-button class="md-icon-button" ng-click="close()">
          <md-icon aria-label="Close dialog">close</md-icon>
        </md-button>
      </div>
    </md-toolbar>
    <md-dialog-content>
      <div class="md-dialog-content">
       <img style="width:100%" ng-show="${!!img}" src="${img}">
       <video style="width:100%" ng-show="${!!video}" width="100%" controls>
          <source src="${video}" type="video/webm">
        </video>
      </div>
    </md-dialog-content>
</md-dialog>`
            });
        }


        private showScreenShot(url) {
            url = url.replace('http://selenium.localhost', 'http://iroda.pentacom.hu');
            this.popupDialog(url, null);
        }

        private showVideo(url) {
            url = url.replace('http://selenium.localhost', 'http://iroda.pentacom.hu');
            this.popupDialog(null, url);
        }



    }

    angular.module("ultimateMonitoringApp").controller("resultTypeListController", ResultTypeListController);
}